import { Container, Stack, Typography } from "@mui/material";
import { PropsWithChildren, ReactNode } from "react";

export interface ErrorContentProps {
    status?: ReactNode,
    title?: ReactNode,
    message?: ReactNode
}

export default function ErrorPage({
    status = "Opps...",
    title = "Hubo un error inesperado",
    message = "Vuelve a intentarlo mas tarde.",
    children 
}:ErrorContentProps&PropsWithChildren) {
    return <Stack minHeight={"100vh"}>
        {children?children:<ErrorContent status={status} title={title} message={message}/>}
    </Stack>
}

function ErrorContent({
    status = "Opps...",
    title = "Hubo un error inesperado",
    message = "Vuelve a intentarlo mas tarde."
}: ErrorContentProps) {
    return <Container component={Stack} flex={1} paddingY={3} justifyContent={"center"} alignItems={"center"}>
        <Typography fontFamily={'"Roboto", sans-serif'} component={"h1"} color="primary.main" fontSize={"4rem"}>{status}</Typography>
        <Stack gap={1} justifyContent={"center"} alignItems={"center"}>
            <Typography variant="h5" component={"h2"} textAlign={"center"}>{title}</Typography>
            <Typography variant="subtitle1" color="text.secondary" textAlign={"center"}>{message}</Typography>
        </Stack>
    </Container>
}

ErrorPage.Content = ErrorContent;